import ImageHelper from '../../../../../utilities/helpers/ImageHelper';
import { UseCurrencyDecorator } from '../../../../../utilities/hooks/UseCurrencyDecorator';
import { useBookingStatuses } from '../../../../../utilities/hooks/useBookingStatuses';
import PropTypes from 'prop-types';
import {DateFormatHelper} from "../../../../../utilities/helpers/DateFormatHelper";
import PaymentStatusListItem from "../../../common/status-label/PaymentStatusListItem";
import {AmountFormatHelper} from "../../../../../utilities/helpers/AmountFormatHelper";
import ProfileImage from '../../../common/ProfileImage';

const ResaleBookingItem = ({ resaleBookingItem }) => {
	const bookingStatuses = useBookingStatuses();
	const currencyDecorator = UseCurrencyDecorator();
	const getBookingStatus = (status) => {
		return (
			<div className={'booking-status ' + bookingStatuses[status].class}>
				{bookingStatuses[status].text}
			</div>
		);
	};

	return (
		<tr>
			<td>
				<div className="booking-number">{resaleBookingItem.display_id}</div>
			</td>
			<td>
				{DateFormatHelper.monthTimeFormat(resaleBookingItem.created_at)}
			</td>
			<td>{getBookingStatus(resaleBookingItem.status.value)}</td>
			<td>
				<div className="booking-customer-container-no-font" style={{gap:'8px'}}>
					<ProfileImage name={resaleBookingItem.provider.brand_name} photo={resaleBookingItem.provider.logo_url} size={{width: 24, height: 24, fontSize: 11, lineHeight: 14}}/>
					<div>{resaleBookingItem.provider.brand_name}</div>
				</div>
			</td>
			<td>
				<div className="experience-table-row-container">
					<div className="experience-table-row-image-container">
						<img
							className="experience-table-row-image-item"
							src={ImageHelper.getFullImageUrl(
								resaleBookingItem.experience.thumbnail
							)}
						/>
					</div>
					<div className="experience-table-row-title-container">
						{resaleBookingItem.experience.title}
					</div>
				</div>
			</td>
			<td>
				{DateFormatHelper.monthTimeFormat(resaleBookingItem.slot_start_time)}
			</td>
			<td>
				{resaleBookingItem?.group?.title}
			</td>
			<td>
				<div className="booking-customer-container-no-font" style={{gap: '8px'}}>
					<ProfileImage name={resaleBookingItem.customer.name} photo={resaleBookingItem.customer.avatar_url} size={{width: 24, height: 24, fontSize: 11, lineHeight: 14}}/>
					<div>{resaleBookingItem.customer.name}</div>
				</div>
			</td>
			<td>
				<PaymentStatusListItem status={resaleBookingItem?.payment_status.value} />
			</td>
			<td>
				<div className="booking-price">
					{currencyDecorator(AmountFormatHelper.formatAmount(resaleBookingItem.amount), resaleBookingItem.currency)}
				</div>
			</td>
			<td>
				<div className="booking-price">
					{currencyDecorator(AmountFormatHelper.formatAmount(resaleBookingItem.reseller_amount), resaleBookingItem.currency)}
				</div>
			</td>
			<td>
				<div className="bookings-actions-wrapper"></div>
			</td>
		</tr>
	);
};

ResaleBookingItem.propTypes = {
	resaleBookingItem: PropTypes.object
};

export default ResaleBookingItem;
